





























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { unescapeHtml } from '@/utils/common';
import { CosBoardsBoardCodeSummary } from 'ncp-api-supporter';
import ArticleNewBadge from '@/components/root/parts/ArticleNewBadge.vue';

type ArticleType = 'notice' | 'update';
type TabKey = 'all' | ArticleType;
// isTopFixed: 상단 고정 게시물 여부 (게시물 API 응답으로 내려오나 supporter 타입에는 아직 미정의)
type TaggedArticle = CosBoardsBoardCodeSummary & { type: ArticleType; isTopFixed?: boolean };

@Component({ components: { ArticleNewBadge } })
export default class ArticleTabList extends Vue {
  @Prop({ required: true })
  private readonly noticeList!: CosBoardsBoardCodeSummary[];
  @Prop({ required: true })
  private readonly upgradeList!: CosBoardsBoardCodeSummary[];
  @Prop({ required: true })
  private readonly noticeLink!: string;
  @Prop({ required: true })
  private readonly upgradeLink!: string;
  @Prop({ required: true })
  private readonly newsLink!: string;

  private activeTab: TabKey = 'all';
  private unescapeHtml = unescapeHtml;

  private get tabs(): { key: TabKey; label: string; link?: string }[] {
    return [
      { key: 'all', label: this.$t('ALL').toString(), link: this.newsLink },
      { key: 'notice', label: this.$t('공지사항').toString(), link: this.noticeLink },
      { key: 'update', label: this.$t('업데이트').toString(), link: this.upgradeLink },
    ];
  }

  private get activeTabInfo(): { key: TabKey; label: string; link?: string } {
    return this.tabs.find(tab => tab.key === this.activeTab) ?? this.tabs[0];
  }

  private onViewAllClick() {
    // 전체보기는 현재 활성화된 탭에 해당하는 게시판 링크로 이동한다
    const { link } = this.activeTabInfo;
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  }

  private get taggedNotices(): TaggedArticle[] {
    return this.noticeList.map(item => ({ ...item, type: 'notice' as const }));
  }

  private get taggedUpdates(): TaggedArticle[] {
    return this.upgradeList.map(item => ({ ...item, type: 'update' as const }));
  }

  private readonly ALL_TAB_MAX_COUNT = 7;

  private sortByPublishedDesc(articles: TaggedArticle[]): TaggedArticle[] {
    return [...articles].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));
  }

  private get filteredArticles(): TaggedArticle[] {
    if (this.activeTab === 'notice') return this.taggedNotices;
    if (this.activeTab === 'update') return this.taggedUpdates;

    // 전체 탭 출력 순위: 1) 상단 고정 공지사항 2) 상단 고정 업데이트 3) 일반 게시글(시간순)
    const all = [...this.taggedNotices, ...this.taggedUpdates];
    const fixedNotices = this.sortByPublishedDesc(all.filter(item => item.isTopFixed && item.type === 'notice'));
    const fixedUpdates = this.sortByPublishedDesc(all.filter(item => item.isTopFixed && item.type === 'update'));
    const normals = this.sortByPublishedDesc(all.filter(item => !item.isTopFixed));

    return [...fixedNotices, ...fixedUpdates, ...normals].slice(0, this.ALL_TAB_MAX_COUNT);
  }

  private get commerceSupportUrl() {
    return `${process.env.VUE_APP_COMMERCE_MAIN}/support/board`;
  }
}
